import React from "react";
import { HeaderVideosType } from "@/types/PageType";
import VidstackPlayer from "@/components/VidstackPlayer/VidstackPlayer";

interface HeaderVideoPlayerProps {
  video: HeaderVideosType;
  autoplay?: boolean;
  singlePageUrl?: string;
}

export const HeaderVideoPlayer = ({
  video,
  autoplay = true,
  singlePageUrl,
}: HeaderVideoPlayerProps) => {
  const hasVideoContent = !!(
    video.internes_video_desktop || video.externes_video
  );

  return (
    <>
      {hasVideoContent && (
        <VidstackPlayer
          video={video}
          autoplay={autoplay}
          muted={true}
          video_decorative={true}
          headerVideo
          singlePageUrl={video.has_single_page ? singlePageUrl : ""}
          sizes="100vw"
        />
      )}
    </>
  );
};
